<template>
    <b-input-group :prepend="name">
        <template v-slot:append>
            <b-btn variant="warning" @click="verify" :disabled="disableVerify || progressing">
                Text PIN
            </b-btn>
            <b-btn variant="danger" @click="reset" :disabled="!(!!phone.length)">
                Clear
            </b-btn>
        </template>
        <b-input-group-append>
            <b-input-group-text class="bg-white" :class="'border-left-0'">
                +1
            </b-input-group-text>
        </b-input-group-append>
        <b-input
            name="Phone Number"
            v-mask="'###-###-####'"
            v-model="phone"
            class="myFeild"
            :placeholder="isRequired"/>
    </b-input-group>
</template>

<script>
    export default {
        name: "phoneNumber",
        props: {
            value: {required: true, type: [String, Number], default: ''},
            orderType: {required: true, type: [String, Number], default: ''},
            model: {required: true, type: Object},
            name: {required: true}
        },
        computed: {
            isRequired () {
                if (this.orderType == 2 || this.orderType == 1) {
                    return "Optional";
                }
                return "Required";
                
            },
            phone: {
              get () {
                  return this.value
              },
              set(val) {
                  this.$emit('input', val)
              }
          },
            disableVerify () {
                return  this.phone ? false : true
            },
            getMobileWithOutMask () {
                if (this.phone) {
                    return this.phone.replace(/-/g, '')
                } else {
                    return ''
                }
            }
        },
        data () {
            return {
                verified: false,
                progressing: false
            }
        },
        methods: {
            verify () {
                let model = {
                    // UserID: localStorage.getItem('userID'),
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    DestPhone: this.getMobileWithOutMask,
                    CustomerName: this.model.customerName
                }
                this.progressing = true
                return this.$api.getRestaurant.SendOTP(model).then(res => {
                    this.progressing = false
                    if (res.success) {
                        this.verified = true
                        this.$emit('getMyKey', res.myIkey)
                    } else {
                        this.verified = false
                        this.$emit('getMyKey', null)
                        this.$showError(res.message)
                    }
                })
            },
            reset () {
                this.phone = ''
            }
        }
    }
</script>

<style scoped>

</style>
